type StatusMessageProps = {
  type: "success" | "error";
  message: string;
  className?: string;
};

const styles = {
  success: "border-emerald-600/40 bg-emerald-700/10 text-emerald-300",
  error: "border-red-600/40 bg-red-700/10 text-red-300",
} as const;

export const StatusMessage = ({
  type,
  message,
  className = "",
}: StatusMessageProps) => {
  return (
    <div
      className={`mb-4 rounded-lg border px-3 py-2 text-sm ${styles[type]} ${className}`}
    >
      {message}
    </div>
  );
};
